export enum GridStackEvents {
  GRID_AUTO_SAVED = 'gridAutoSaved',
}
